import { msg } from '@lingui/macro';

export const SuppliersRoutes = {
  path: 'suppliers',
  async lazy() {
    const { Parent } = await import('pages/my-subsuppliers');
    return { Component: Parent };
  },
  handle: {
    name: 'My subsuppliers',
    category: 'My subsuppliers list view',
    title: msg`My subsuppliers`,
    supplierTitle: msg`Subsuppliers & facilities`,
  },
  children: [
    {
      index: true,
      async lazy() {
        const { Landing } = await import('pages/my-subsuppliers');
        return { Component: Landing };
      },
    },
    {
      async lazy() {
        const { TabShell } = await import('pages/my-subsuppliers');
        return { Component: TabShell };
      },
      children: [
        {
          path: 'subsuppliers',
          async lazy() {
            const { Index } = await import('pages/my-subsuppliers');
            return { Component: Index };
          },
          handle: { name: 'Subsuppliers', category: 'My subsuppliers list view' },
        },
        {
          path: 'facilities',
          async lazy() {
            const { AllFacilities } = await import('pages/my-subsuppliers');
            return { Component: AllFacilities };
          },
          handle: { name: 'Facilities', category: 'My subsuppliers list view' },
          children: [
            {
              path: 'add',
              async lazy() {
                const { AllFacilitiesAddModal } = await import('pages/my-subsuppliers');
                return { Component: AllFacilitiesAddModal };
              },
            },
            {
              path: ':facilityId/edit',
              async lazy() {
                const { AllFacilitiesEditModal } = await import('pages/my-subsuppliers');
                return { Component: AllFacilitiesEditModal };
              },
            },
            {
              path: ':facilityId/details',
              async lazy() {
                const { AllFacilityDetailsPage } = await import('pages/my-subsuppliers');
                return { Component: AllFacilityDetailsPage };
              },
            },
          ],
        },
        {
          path: 'certificates',
          async lazy() {
            const { AllCertificates } = await import('pages/my-subsuppliers');
            return { Component: AllCertificates };
          },
          handle: { name: 'Certificates', category: 'My subsuppliers list view' },
        },
      ],
    },
    {
      path: ':supplierId/:supplierOrgId',
      async lazy() {
        const { Details } = await import('pages/my-subsuppliers');
        return { Component: Details };
      },
      handle: { name: 'Supplier Detail Page', category: 'My subsuppliers' },
      children: [
        {
          index: true,
          async lazy() {
            const { BasicInfo } = await import('pages/my-subsuppliers');
            return { Component: BasicInfo };
          },
        },
        {
          path: 'edit',
          async lazy() {
            const { EditSupplier } = await import('pages/my-subsuppliers');
            return { Component: EditSupplier };
          },
          handle: { name: 'Edit supplier', category: 'My subsuppliers' },
        },
        {
          path: 'facilities',
          async lazy() {
            const { Facilities } = await import('pages/my-subsuppliers');
            return { Component: Facilities };
          },
          handle: { name: 'Facilities', category: 'My subsuppliers' },
          children: [
            {
              path: 'add',
              async lazy() {
                const { SupplierFacilitiesModal } = await import('pages/my-subsuppliers');
                return { Component: SupplierFacilitiesModal };
              },
            },
            {
              path: ':facilityId/edit',
              async lazy() {
                const { SupplierFacilitiesEditModal } = await import('pages/my-subsuppliers');
                return { Component: SupplierFacilitiesEditModal };
              },
            },
            {
              path: ':facilityId/details',
              async lazy() {
                const { SupplierFacilityDetails } = await import('pages/my-subsuppliers');
                return { Component: SupplierFacilityDetails };
              },
            },
          ],
        },
      ],
    },
    {
      path: 'add',
      async lazy() {
        const { AddSupplier } = await import('pages/my-subsuppliers');
        return { Component: AddSupplier };
      },
      handle: { name: 'Add new supplier', category: 'My subsuppliers' },
    },
  ],
};
